/**
 * Full-page navigation to the SSO login endpoint (redirect-mode
 * auto-forward, .scratch/oauth2-ldap-auth/03). A full load is required so
 * the API can 302 through the provider dance. Kept behind this helper so
 * tests can spy on the navigation instead of fighting jsdom's location.
 */
export function goToSsoLogin(href: string): void {
  window.location.assign(href);
}

interface LocalAuthFlags {
  localAuthDisabled: boolean;
  localDisabled: boolean;
}

/**
 * Whether the login view must hide the password form (kill-switch,
 * .scratch/oauth2-ldap-auth/03). The discovery response carries the flag
 * twice (`localAuthDisabled` + its `localDisabled` alias) — either one on
 * means local password login is refused.
 */
export function isLocalAuthDisabled(config: LocalAuthFlags | null | undefined): boolean {
  return config?.localAuthDisabled === true || config?.localDisabled === true;
}
